import { render, staticRenderFns } from "./GlobalStyles.vue?vue&type=template&id=2300e962&"
import script from "./GlobalStyles.vue?vue&type=script&lang=js&"
export * from "./GlobalStyles.vue?vue&type=script&lang=js&"
import style0 from "./GlobalStyles.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports